import React, { Component } from "react"
import "./Remote.scss"
import ScrollableAnchor from "react-scrollable-anchor";
import GreenList from "../GreenList/GreenList";
import PopupMobile from "./PopupMobile";
import InfoBoxes from "./InfoBoxes";
import MouseOver from "./MouseOver";
import Pulses from "./Pulses";

class Remote extends Component {
    constructor(props) {
        super();
        this.showInfobox = this.showInfobox.bind(this);
        this.state = {
            currentActive: -1
        }
    }
    showInfobox(index) {
        this.setState({
            currentActive: index
        })
    }
    render() {
        return (
            <div style={{ position: "relative" }}>
                <GreenList index={3} max={5} className="bottom" />
                <ScrollableAnchor id="remote">
                    <section className="section section-remote">
                        <div className="padding-remote">
                            <div className="container">
                                <div className="headline">
                                    <div className="head">
                                        השלט האולטימטיבי
                                    </div>
                                    <div className="separator">
                                    </div>
                                    <div className="desc">
                                        שינינו קצת את הפעולות של השלט שלנו כדי שיתאימו בדיוק
    למה שתצטרכו כדי ליהנות מהמונדיאל הזה. כן נו, לחצו ובדקו אותנו
                                    </div>
                                </div>
                                <div className="remote">
                                    {/* <Pulses /> */}
                                    <MouseOver showInfobox={this.showInfobox} />
                                </div>
                                <InfoBoxes current={this.state.currentActive} />
                                <PopupMobile current={this.state.currentActive} />
                            </div>
                        </div>
                    </section>
                </ScrollableAnchor>
            </div >
        )
    }
}

export default Remote;


// WEBPACK FOOTER //
// ./src/Components/Remote/Remote.jsx